import { css } from "@emotion/css";
import { Colors } from "@analyticsMD/quil";
import {
  UI_ACCENT_BLUE,
  UI_ACCENT_BLUE_HOVER,
  UI_ACCENT_BLUE_OPTION_FOCUS,
} from "../../../constants/ui-colors";

export const styles = {
  scrollbar: css`
    &::-webkit-scrollbar {
      width: 0.5rem;
      background-color: white;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 7.5px;
      background-color: ${Colors.grey_15};
    }
  `,
};

export const sxStyles = {
  buttonsWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "1rem",
    gap: "0.5rem",
    fontWeight: "bold",
  },
  listbox: {
    maxHeight: 170,
    padding: 10,
  },
  listItem: {
    paddingLeft: "0.5rem !important",
    paddingBottom: "0.5rem !important",
    fontSize: "0.9rem",
  },
  checkbox: {
    marginRight: "0.5rem",
    padding: "0.25rem",
    color: UI_ACCENT_BLUE,
    "&.Mui-checked": {
      color: UI_ACCENT_BLUE,
    },
  },
  autocompleteListbox: {
    "& .MuiAutocomplete-option": {
      "&:hover": {
        backgroundColor: `${UI_ACCENT_BLUE_HOVER} !important`,
      },
      "&.Mui-focused": {
        backgroundColor: `${UI_ACCENT_BLUE_OPTION_FOCUS} !important`,
      },
      '&[aria-selected="true"]': {
        backgroundColor: `${UI_ACCENT_BLUE_OPTION_FOCUS} !important`,
      },
    },
  },
  milestoneOutlinedInput: {
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: `${UI_ACCENT_BLUE} !important`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${UI_ACCENT_BLUE} !important`,
    },
  },
  milestoneInputLabelFocused: {
    "&.Mui-focused": {
      color: `${UI_ACCENT_BLUE} !important`,
    },
  },
  cancelButton: {
    textTransform: "capitalize",
    fontWeight: "bold",
    color: UI_ACCENT_BLUE,
    "&:hover": {
      backgroundColor: UI_ACCENT_BLUE_HOVER,
    },
  },
  doneButtonContained: {
    textTransform: "capitalize",
    fontWeight: "bold",
    backgroundColor: UI_ACCENT_BLUE,
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1565c0",
      boxShadow: "none",
    },
  },
  inputLabel: {
    fontSize: "0.75rem",
    top: "3px",
  },
  outlinedInput: {
    fontSize: "0.9rem",
    width: "100%",
  },
  outlinedInputProp: {
    textAlign: "left",
    paddingLeft: "0.5rem",
    fontSize: "0.9rem",
  },
  tagText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginRight: "0.25rem",
    display: "inline-block",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
  }
};
